import { Component, Input } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import getDocDefinition from '../pdfExport/docDefinition';
import moment from 'moment';

@Component({
  selector: 'app-printable-page',
  templateUrl: 'printable-page.component.html',
  styleUrls: ['printable-page.component.scss']
})
export class PrintablePageComponent {
  @Input() private agGridReference: AgGridAngular;
  @Input() private title: string;
  @Input() private subTitle: string;
  @Input() private pivotMode: boolean = false;
  @Input() private rowBold: [];
  @Input() private rowPercentage: [];
  agGridColumnApi: any;
  agGridApi: any;
  constructor() {
  }
  ngOnInit() {
    
  }
  onPrintable() {
    
    //const htmlTable = "<h1>Happy New Year</h1>";
    const currentDate = moment().format('YYYY-MM-DD');
    const currentTime = moment().format('hh:mm:ss A');
    this.agGridColumnApi = this.agGridReference.columnApi;
    this.agGridApi = this.agGridReference.api;
    //this.filename = this.title;
    const printParams = {
      PDF_TITLE: this.title,
      PDF_SUB_TITLE: this.subTitle,
      PDF_GENERATED_ON: `Generated on ${currentDate} ${currentTime}`,
      PDF_HEADER_COLOR: "#f8f8f8",
      PDF_INNER_BORDER_COLOR: "#dde2eb",
      PDF_OUTER_BORDER_COLOR: "#babfc7",
      PDF_LOGO : "",
      PDF_PAGE_ORITENTATION: 'portrait',
      PDF_WITH_HEADER_IMAGE: false,
      PDF_WITH_FOOTER_PAGE_COUNT: false,
      PDF_HEADER_HEIGHT: 10,
      PDF_ROW_HEIGHT: 10,
      PDF_ODD_BKG_COLOR: "#fcfcfc",
      PDF_EVEN_BKG_COLOR: "#ffffff",
      PDF_WITH_CELL_FORMATTING: true,
      PDF_WITH_COLUMNS_AS_LINKS: true,
      PDF_SELECTED_ROWS_ONLY: false,
      PDF_FILENAME: this.title.replace(/\s/g,'') + "_" + currentDate,
      PDF_PIVOT_MODE: this.pivotMode,
      PDF_ROW_BOLD: this.rowBold,
      PDF_ROW_PERCENTAGE: this.rowPercentage
    };
    const docDefinition = getDocDefinition(printParams, this.agGridReference.api, this.agGridReference.columnApi);
    console.log(docDefinition);
    // console.log('style', this.getStyle());
    const htmlHeader = `<html>
        ${this.getStyle()}
        <head>
        <title>${this.title}</title>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.17.0/xlsx.full.min.js"></script>
        </head>
        <body>
        <table width='100%' border='0' bgcolor='white'>
        <tr>
        <td valign='top' align='center' class='bold-text'>`;
    let title = "";
    let exportLink = `<table class='noborder'><tr><td align='right'>
    <img src='assets/images/exportxls.png' width='16px'><a href='#' class='smalllink' onclick='exportToCSV()'>Export CSV</a>
    &nbsp;<img src='assets/images/exportxls.png' width='16px'><a href='#' class='smalllink' onclick='exportToXLSX()'>Export XLS</a>
                </td></tr></table>`;
    let tableContent = "<table class='printable' id='dataTable'><thead>";
    let headerIndex = 0;    
    if (docDefinition && docDefinition.content) {
      docDefinition.content.forEach(content => {
        if (content) {
          if (content.style === 'header') {
            headerIndex += 1;
            if (headerIndex === 1) {
              title += `<font size='+1'>${content.text}</font><br>`;
            }
            else {
              title += `<font size='-1'>${content.text}</font><br>`;
            }
          }
          else if (content.style === 'myTable') {
            const body = content.table.body;
            body.forEach((row, rowIndex) => {
              tableContent += '<tr>';
              let isColspan = false;
              row.forEach((cell, cellIndex) => {
                const colSpan = cell.colSpan? `colSpan=${cell.colSpan}`:'';
                if (this.isObjectEmpty(cell) && !isColspan) {
                  tableContent += `<th align=""></th>`;
                }
                else if (cell.style === 'tableHeader') {
                  const alignment = cell.pdfExportOptions && cell.pdfExportOptions.styles && cell.pdfExportOptions.styles.alignment
                    ? cell.pdfExportOptions.styles.alignment: 'left';
                  tableContent += `<th align="${alignment}" ${colSpan}>${cell.text}</th>`;
                }
                else if (cell.style === 'tableCell') {
                  const alignment = cell.alignment ? cell.alignment: 'left';
                  const bold = cell.bold ? 'class="bold-text"':'';
                  tableContent += `<td align="${alignment}" ${colSpan} ${bold}>${cell.text}</td>`;
                }
                else if (cell.style === 'tableFooter') {
                  const alignment = cell.alignment ? cell.alignment: 'left';
                  tableContent += `<td align="${alignment}" ${colSpan} class="summary">${cell.text}</td>`;
                }
                if (cell.colSpan) {
                  isColspan = true;
                }
              });
              tableContent += '</tr>';
              if (rowIndex == 0) tableContent += '</thead><tbody>';
            });
          }       
        }
      })
    }
    tableContent += "</tbody></table>";
    const htmlScript = this.getScript();
    const htmlFooter = `</body></html>`;
    const htmlContent = htmlHeader + title + `</tbody></table>` + exportLink + tableContent + htmlScript + htmlFooter;
    this.openHtmlInNewPage(htmlContent);
  }

  openHtmlInNewPage(htmlContent: string) {
    const newWindow = window.open('', '_blank');
    // Write the HTML content to the new window
    newWindow.document.write(htmlContent);
    // Close the document to ensure proper rendering
    newWindow.document.close();
  }

  getStyle() {
    const style = 
    `<style>
      body {
        font-family: verdana, helvetica, arial, sans-serif;
      }
      a.smalllink {
        text-decoration: none;
        font-size: 8pt;
        color: #0048FF;
        font-weight: normal
      }
      
      a.smalllink:hover {
        text-decoration: underline;
        font-size: 8pt;
        color: #c61a1a;
        font-weight: normal
      }
      .bold-text {
	      font-weight: bold;
      }
      table.printable {
        width: 100%;
        font-size: 12px;
        border-spacing: 0;
        border-collapse: collapse;	
      }
      table.printable tbody tr:hover {
        background-color: #ffffdd;
      }
      table.printable th {
        color: #000000;
        background-color: #dddddd;
        /*border: 1px solid #808080;*/
        font-size: 100%;
        padding: 3px;
        vertical-align: top;
        text-align: center;
        word-wrap: break-word;
        border-top: 1px solid;
        border-bottom: 1px solid;
        border-left: none;
        border-right: none;
      }
      table.printable td {
        white-space: pre;
        /*border: 1px solid #808080;*/
        padding: 3px;
        padding-top: 3px;
        padding-bottom: 3px;
        vertical-align: top;
        word-wrap: break-word;
        border-top: none;
        border-bottom: none;
        border-left: none;
        border-right: none;
      }
      table.printable tr.summary {
        font-weight: bold;
        font-size: 100%;
        border-top: 1px solid;
        border-bottom: 1px solid;
        border-left: none;
        border-right: none;
      }
      table.printable tr.maincontent {	
        font-weight: bold;
        font-size: 100%;
      }
      table.noborder {
        width: 100%;
        padding: 0px;
        font-size: 12px;
        border: 0px;
        border-collapse: collapse;
      }
    </style>`;
    return style;
  }
  
  isObjectEmpty(obj: any): boolean {
    return Object.keys(obj).length === 0;
  }
  
  getScript() {
    return `<script>
      function exportToCSV() {
        const table = document.getElementById("dataTable");
        const rows = table.getElementsByTagName("tr");
        const csvData = [];
        
        for (let i = 0; i < rows.length; i++) {
          const row = [], cols = rows[i].querySelectorAll("td, th");
          for (let j = 0; j < cols.length; j++) {
            // Handling commas within cell values
            row.push('"' + cols[j].innerText.trim().replace(/"/g, '""') + '"');
          }
          csvData.push(row.join(","));
        }
        
        const csvContent = csvData.join("\\n");
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        
        if (navigator.msSaveBlob) { // IE 10+
          navigator.msSaveBlob(blob, "${this.title.replace(/\n/g, '')}.csv");
        } else {
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", "${this.title.replace(/\n/g, '')}.csv");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }

      function exportToXLSX() {
        const table = document.getElementById("dataTable");
        const rows = table.getElementsByTagName("tr");
        const xlsxData = [];
        
        for (let i = 0; i < rows.length; i++) {
          const row = [], cols = rows[i].querySelectorAll("td, th");
          for (let j = 0; j < cols.length; j++) {
            row.push(cols[j].innerText.trim());
          }
          xlsxData.push(row);
        }
        
        const worksheet = XLSX.utils.aoa_to_sheet(xlsxData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        
        // Save the workbook as XLSX file
        XLSX.writeFile(workbook, "${this.title.replace(/\n/g, '')}.xlsx");
      }
    </script>`
    ;
  }
}